import React, { Component } from 'react';
import moment from 'moment';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'

class ChangelogCard extends React.Component {
	getEmbedIframeUrl(type, url) {
	  if (!url) return null;
	  try { new URL(url); } catch(e) { return null; }
	
	  if (type === 'loom') {
		var loomMatch = url.match(/loom\.com\/share\/([a-zA-Z0-9]+)/);
		if (loomMatch) return 'https://www.loom.com/embed/' + loomMatch[1];
	  }
	  if (type === 'youtube') {
		var ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
		if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1];
	  }
	  if (type === 'tango') {
		return url.replace('/app/workflow/', '/app/embed/');
	  }
	  if (type === 'notion') {
		return url;
	  }
	  if (type === 'url') {
		return url;
	  }
	  return null;
	}
	
	renderIframe(entry) {
		const url = this.getEmbedIframeUrl(entry.embed_type, entry.embed_url);
		if(!url)
			return null;
		return <iframe src={url} />	
	}
	
	render() {
		const { entry } = this.props;
		return <div className="changelog-card">
			<div className="changelog-card-header">
				<div className="changelog-card-tag-list">
					{entry.update_types.map(type=><span key={type} className={`changelog-card-tag changelog-card-tag-${type.toLowerCase()}`}>{type.toUpperCase()}</span>)}
				</div>
				<span className="changelog-card-date">{moment(entry.published_at).format('MMMM D, YYYY')}</span>
			</div>
			<h4 className="changelog-card-title">{entry.title}</h4>
			<p className="changelog-card-description">{entry.description}</p>
			<div className="changelog-card-body">
				<ReactMarkdown remarkPlugins={[remarkGfm]}>{entry.body}</ReactMarkdown>
			</div>
			{this.renderIframe(entry)}
			{entry.cta_buttons && <div className="changelog-card-buttons-holder">
				{entry.cta_buttons.map(cta=><a key={cta.url} className={`changelog-card-button default-btn default-btn--tiny button`} target="_blank" href={cta.url}>{cta.label}</a>)}
			</div>}
		</div>	
	}
}

export default ChangelogCard;